// extracted by mini-css-extract-plugin
module.exports = {"code":"WidgetCode_code_1zDem"};